import { render, staticRenderFns } from "./Firebase.vue?vue&type=template&id=07152ad9&scoped=true"
import script from "./Firebase.vue?vue&type=script&lang=js"
export * from "./Firebase.vue?vue&type=script&lang=js"
import style0 from "./Firebase.vue?vue&type=style&index=0&id=07152ad9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07152ad9",
  null
  
)

export default component.exports